<template>
  <div class="auth">
    <header>
      <div
        class="back"
        @click="$router.back()"
        v-if="!$route.query.repass"
      >
        <van-icon name="arrow-left" />
      </div>
      <div class="logo-image">
        <img src="@/assets/imgs/product_logo.png" alt="" />
      </div>
    </header>
    <main>
      <div class="form-box">
        <div class="form-item title">{{ $t('passwordTitle') }}</div>
        <!-- <div class="form-item">
          <van-cell-group>
            <van-field
              v-model="phone"
              placeholder="请输入手机号"
              type="tel"
            />
          </van-cell-group>
        </div> -->
        <div class="form-item">
          <van-cell-group>
            <van-field
              v-model="password"
              :placeholder="$t('updatePasswordPlace')"
              type="password"
            />
          </van-cell-group>
        </div>
        <!-- <div class="form-item">
          <input
            type="password"
            placeholder="请输入再次新密码"
            v-model="renewPassword"
            @blur="onBlur"
          />
        </div> -->
        <div class="form-item">
          <button :disabled="isDis" @click="handleSubmit">
            {{ loginStatus ? $t('updating') : $t('updateTips') }}
          </button>
        </div>
        <!-- <div class="form-item info">* 初始密码为 000000</div> -->
        <!-- <div class="form-item info">* 密码不能少于6位</div> -->
      </div>
    </main>
  </div>
</template>

<script>
import { resetScroll } from "@/common/dom";
export default {
  data() {
    return {
      phone: '',
      password: "",
      renewPassword: "",
      oldPassword: localStorage.getItem("userPhone"),
      loginStatus: 0,
      shopId:localStorage.getItem('shopId')
    };
  },
  computed: {
    isDis() {
      return !this.password;
    },
  },
  created() {
    // if (!this.customerId) {
    //   this.$router.replace('/login');
    //   return this.$toast('请先登录');
    // }
  },
  methods: {
    onBlur() {
      resetScroll();
    },
    async handleSubmit() {
      if (this.loginStatus) {
        return;
      }
      if (this.isDis) {
        this.$toast(this.$t('updatePasswordPlace'));
        return;
      }
      const { phone, password } = this;
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{8,16}$/;
      if (!regex.test(password)) {
        this.$toast(this.$t('passwordRules'));
        return;
      }
      this.loginStatus = 1;
      try {
        const { data: resData } = await this.$authAjax.post(
          "/api/wxapp/updatePassword",
          {
            // phone: localStorage.getItem('phone'),
            token: sessionStorage.getItem("token"),
            password,
            // shopId: localStorage.getItem("shopId")
          }
        );
        if (resData.code == 200) {
          // this.$toast("修改成功，请重新登录");
          // sessionStorage.clear();
          localStorage.removeItem("password");
          // localStorage.removeItem("phone")
          this.$router.replace("/login");
        } else {
          this.$toast(resData.message);
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
      this.loginStatus = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./auth.scss";
</style>
